import React from "react";
import { Box, Skeleton } from "@mui/material";

export default function ProductCardSkeleton({ showLabel = true }) {
  return (
    <Box>
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          width: "100%",
          aspectRatio: "1 / 1",
          borderRadius: "24px",
          mb: 1,
          bgcolor: "rgba(0, 0, 0, 0.06)",
        }}
      />
      {showLabel && (
        <Skeleton
          variant="text"
          animation="wave"
          sx={{
            fontSize: "20px",
            width: "60%",
            ml: 2,
            mt: 1,
            bgcolor: "rgba(0, 0, 0, 0.06)",
          }}
        />
      )}
    </Box>
  );
}
